enum UserStatusEnum {
  ACTIVE = 'active',
  DRAFT = 'draft',
  INACTIVE = 'inactive',
}

export default UserStatusEnum;
